import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template16.css";
import "./CheckoutTemplate16.css";

/*
   Checkout Template 16 — a seamless continuation of sales Template 16
   ("Nebula Dashboard", premium DARK, electric indigo/blue). Reuses
   Template16.css directly (same .clp16-root design system): the drifting
   nebula/star background, the fixed glass .nx16-nav, the dark .nx16-hero
   with its gradient-accent .nx16-title/.nx16-grad, the glowing
   .nx16-btn.nx16-btn-p button and the .nx16-foot footer. Only the form +
   order summary cards are checkout-specific (CheckoutTemplate16.css), styled
   as dark glass panels to match the template's .nx16-card look.
*/
export default function ThankYouTemplate16({ data = {} }) {
  const c = copy(data);

  return (
    <div className="clp16-root">
      {/* Drifting nebula glow + star field — same as the sales page */}
      <div className="nx16-space" aria-hidden="true">
        <span className="nx16-neb nx16-neb1" />
        <span className="nx16-neb nx16-neb2" />
        <span className="nx16-neb nx16-neb3" />
        <span className="nx16-stars" />
      </div>

      {/* NAV — same as the sales page */}
      <nav className="nx16-nav scr">
        <div className="nx16-wrap nx16-nav-in">
          <span className="nx16-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok16-brandtext">{c.brand}</span>}
          </span>
          <span className="cok16-secure">✓ Order confirmed</span>
        </div>
      </nav>

      {/* HERO — reuses the sales hero band + gradient-accent title */}
      <header className="nx16-hero cok16-hero" id="top">
        <div className="nx16-wrap">
          <div className="cok16-hero-in">
            <span className="cok16-eyebrow">Thank you</span>
            <h1 className="nx16-title">
              You're <span className="nx16-grad">enrolled</span>
            </h1>
            {c.sub ? <p className="nx16-sub cok16-sub">{c.sub}</p> : null}
          </div>
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's dark-glass card style */}
      <div className="nx16-wrap">
        <ThankYouBody data={data} p="cok16" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="nx16-foot">
        <div className="nx16-wrap nx16-foot-in">
          <div className="cok16-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
